import {
  BooleanValue,
  DatetimeValue,
  DateValue,
  FieldDataType,
  NumericValue,
  ResourceValue,
  SingleSelectValue,
  SpecificFieldValue,
  TextValue,
  TimeValue,
  UserValue,
} from 'mapistry-shared';

interface FieldValueFactoryParams<
  T extends FieldDataType,
  V extends SpecificFieldValue,
> {
  fieldType: T;
  fieldValue: V;
}

export function fieldValueFactory<
  T extends FieldDataType.BOOLEAN,
  V extends SpecificFieldValue,
>({
  fieldType,
  fieldValue,
}: FieldValueFactoryParams<T, V>): BooleanValue | null;
export function fieldValueFactory<
  T extends FieldDataType.DATE,
  V extends SpecificFieldValue,
>({ fieldType, fieldValue }: FieldValueFactoryParams<T, V>): DateValue | null;
export function fieldValueFactory<
  T extends FieldDataType.DATETIME,
  V extends SpecificFieldValue,
>({
  fieldType,
  fieldValue,
}: FieldValueFactoryParams<T, V>): DatetimeValue | null;
export function fieldValueFactory<
  T extends FieldDataType.NUMERIC,
  V extends SpecificFieldValue,
>({
  fieldType,
  fieldValue,
}: FieldValueFactoryParams<T, V>): NumericValue | null;
export function fieldValueFactory<
  T extends FieldDataType.RESOURCE,
  V extends SpecificFieldValue,
>({
  fieldType,
  fieldValue,
}: FieldValueFactoryParams<T, V>): ResourceValue | null;
export function fieldValueFactory<
  T extends FieldDataType.SINGLE_SELECT,
  V extends SpecificFieldValue,
>({
  fieldType,
  fieldValue,
}: FieldValueFactoryParams<T, V>): SingleSelectValue | null;
export function fieldValueFactory<
  T extends FieldDataType.TEXT,
  V extends SpecificFieldValue,
>({ fieldType, fieldValue }: FieldValueFactoryParams<T, V>): TextValue | null;
export function fieldValueFactory<
  T extends FieldDataType.TIME,
  V extends SpecificFieldValue,
>({ fieldType, fieldValue }: FieldValueFactoryParams<T, V>): TimeValue | null;
export function fieldValueFactory<
  T extends FieldDataType.USER,
  V extends SpecificFieldValue,
>({ fieldType, fieldValue }: FieldValueFactoryParams<T, V>): UserValue | null;
export function fieldValueFactory({
  fieldType,
  fieldValue,
}: FieldValueFactoryParams<FieldDataType, SpecificFieldValue>) {
  const defaultResult = null;
  if (fieldValue.value == null) {
    return null;
  }
  switch (fieldType) {
    case FieldDataType.BOOLEAN:
      return fieldValue as BooleanValue;
    case FieldDataType.DATE:
      return fieldValue as DateValue;
    case FieldDataType.DATETIME:
      return fieldValue as DatetimeValue;
    case FieldDataType.NUMERIC:
      return fieldValue as NumericValue;
    case FieldDataType.RESOURCE:
      return fieldValue as ResourceValue;
    case FieldDataType.SINGLE_SELECT:
      return fieldValue as SingleSelectValue;
    case FieldDataType.TEXT:
      return fieldValue as TextValue;
    case FieldDataType.TIME:
      return fieldValue as TimeValue;
    case FieldDataType.USER:
      return fieldValue as UserValue;
    default:
      return defaultResult;
  }
}
